import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Obtener el registro por id
export const getCompanyById = async (id) => {
    const { data } = await axios.get(`${API_ROUTES.COMPANIES}/${id}`);
    return data;
};
// procedimiento actualizar
export const updateCompany = async (id, payload) => {
    const { data } = await axios.put(`${API_ROUTES.COMPANIES}/${id}`, payload);
    return data;
};